import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { registerUser } from '../services/api';
import Navbar from '../components/Navbar';
import { useTheme } from '../context/ThemeContext';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function Register() {
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const { colors } = useTheme();

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    setError('');
    if (!form.name || !form.email || !form.password || !form.confirmPassword) return setError('Rellena todos los campos');
    if (form.password !== form.confirmPassword) return setError('Las contraseñas no coinciden');
    if (form.password.length < 6) return setError('La contraseña debe tener al menos 6 caracteres');
    setLoading(true);
    try {
      const res = await registerUser({ name: form.name, email: form.email, password: form.password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al registrarse');
    }
    setLoading(false);
  };

  const fields = [
    { label: 'Nombre completo', name: 'name', type: 'text', placeholder: 'Tu nombre', hasEye: false },
    { label: 'Email', name: 'email', type: 'email', placeholder: 'tu@email.com', hasEye: false },
    { label: 'Contraseña', name: 'password', type: showPassword ? 'text' : 'password', placeholder: 'Mínimo 6 caracteres', hasEye: true, show: showPassword, toggle: () => setShowPassword(v => !v) },
    { label: 'Confirmar contraseña', name: 'confirmPassword', type: showConfirm ? 'text' : 'password', placeholder: 'Repite la contraseña', hasEye: true, show: showConfirm, toggle: () => setShowConfirm(v => !v) },
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.bg }}>
      <Navbar />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '4rem 2rem' }}>
        <div style={{ backgroundColor: colors.bgSecondary, border: `1px solid ${colors.border}`, borderRadius: '16px', padding: '2.5rem', width: '100%', maxWidth: '420px' }}>
          <h1 style={{ color: colors.text, fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Crear cuenta</h1>
          <p style={{ color: colors.textSecondary, fontSize: '0.95rem', marginBottom: '2rem' }}>Únete a Galiticket y compra tus entradas</p>
          {error && <div style={{ backgroundColor: '#ff444422', border: '1px solid #ff4444', color: '#ff4444', padding: '0.8rem 1rem', borderRadius: '8px', marginBottom: '1.5rem', fontSize: '0.9rem' }}>{error}</div>}
          {fields.map(field => (
            <div key={field.name} style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', marginBottom: '1.2rem' }}>
              <label style={{ color: colors.textSecondary, fontSize: '0.85rem' }}>{field.label}</label>
              <div style={{ position: 'relative' }}>
                <input style={{ width: '100%', backgroundColor: colors.inputBg, border: `1px solid ${colors.border}`, borderRadius: '8px', padding: field.hasEye ? '0.7rem 3rem 0.7rem 1rem' : '0.7rem 1rem', color: colors.text, fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box' }} name={field.name} type={field.type} placeholder={field.placeholder} value={form[field.name]} onChange={handleChange} />
                {field.hasEye && (
                  <button type="button" onClick={field.toggle} style={{ position: 'absolute', right: '0.8rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: colors.textSecondary, display: 'flex', alignItems: 'center', padding: 0 }}>
                    {field.show ? <VisibilityOffIcon style={{ fontSize: 20 }} /> : <VisibilityIcon style={{ fontSize: 20 }} />}
                  </button>
                )}
              </div>
            </div>
          ))}
          <button style={{ backgroundColor: colors.accent, color: colors.accentText, border: 'none', padding: '0.8rem', borderRadius: '25px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1rem', width: '100%', marginTop: '0.5rem' }} onClick={handleSubmit} disabled={loading}>
            {loading ? 'Creando cuenta...' : 'Crear cuenta'}
          </button>
          <p style={{ color: colors.textSecondary, fontSize: '0.9rem', textAlign: 'center', marginTop: '1.5rem' }}>
            ¿Ya tienes cuenta? <Link to="/login" style={{ color: colors.accent, textDecoration: 'none', fontWeight: 'bold' }}>Inicia sesión</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;